import { ModelDef } from '../../CORE/src/common/$models/ModelDef'
import { toStartDateVersionCode } from '../services/YhcMasterDataGenerator/masterVersionCode'
import {
  hydrateYhcMastersWithVersionPeriod,
  stripYhcMastersVirtualPeriodFields,
  syncYhcMasterVersionFromMastersForm,
} from '../services/YhcMasterDataGenerator/syncYhcMasterVersionFromMastersForm'

/**
 * YHC マスタデータ
 * - Excel ファイルを登録し、バージョン単位で取込実行する
 * - 有効期間・説明は yhc_master_versions と同期（画面は本モデルに集約）
 */
export const yhc_masters: ModelDef = {
  tableName: 'yhc_masters',
  tableLabel: 'YHC マスタデータ',
  primaryKeyColType: 'UUID',
  columns: {
    versionUpdateButton: {
      type: 'STRING',
      label: '取込実行',
      replicable: true,
      doNotSyncModel: true,
      enableIf: () => false,
      listLabelFormatter: (row) =>
        `<span class="ignoreItemClick btn btn-outline-primary btn-sm" onclick="$core.$yhc.openKickMasterDataImportWithVersionModal('${row.id}')">取込実行</span>`,
      orderOnForm: 90,
    },
    enabledFrom: {
      type: 'DATETIME',
      label: '有効期間 開始',
      doNotSyncModel: true,
      replicable: true,
      validate: { notEmpty: true },
      width: { md: 12 },
      orderOnForm: 10,
      inputHelpText:
        '新規保存時、この開始日からバージョンコード (YYYY.MM.DD) を自動採番します。同一開始日は1件までです。',
    },
    disabledAt: {
      type: 'DATETIME',
      label: '有効期間 終了',
      doNotSyncModel: true,
      replicable: true,
      validate: { notEmpty: true },
      width: { md: 12 },
      orderOnForm: 11,
    },
    versionDesc: {
      type: 'TEXT',
      label: 'バージョン説明',
      doNotSyncModel: true,
      replicable: true,
      validate: { notEmpty: true },
      width: { md: 48 },
      orderOnForm: 12,
      inputHelpText: '見積・管理で使う版の説明です（管理用メモとは別）。',
    },
    version: {
      type: 'STRING',
      label: 'バージョン',
      unique: true,
      editable: false,
      editableOnCreate: false,
      replicable: false,
      width: { md: 8 },
      orderOnForm: 13,
      inputHelpText:
        '作成時に有効期間開始日 (YYYY.MM.DD) から自動採番されます。作成後は変更されません。',
    },
    zipcode_master_file: {
      type: 'FILEUPLOAD',
      label: '基幹郵便番号マスタ (Excel)',
      replicable: true,
      visibleOnIndex: false,
      width: { md: 10 },
      inputAttrs: { filePathPrefix: '/private/yhc_master' },
      orderOnForm: 20,
    },
    minreqday_master_file: {
      type: 'FILEUPLOAD',
      label: '最短所要日数マスタ (Excel)',
      replicable: true,
      visibleOnIndex: false,
      width: { md: 10 },
      inputAttrs: { filePathPrefix: '/private/yhc_master' },
      orderOnForm: 21,
    },
    hours_master_file: {
      type: 'FILEUPLOAD',
      label: '時間帯マスタ (Excel)',
      replicable: true,
      visibleOnIndex: false,
      width: { md: 10 },
      inputAttrs: { filePathPrefix: '/private/yhc_master' },
      orderOnForm: 22,
    },
    prices_master_file: {
      type: 'FILEUPLOAD',
      label: '家財料金表【通達配信版】 (Excel)',
      replicable: true,
      visibleOnIndex: false,
      width: { md: 10 },
      inputAttrs: { filePathPrefix: '/private/yhc_master' },
      orderOnForm: 23,
    },
    note: {
      type: 'TEXT',
      label: '管理用メモ',
      width: { md: 48 },
      inputAttrs: { maxHeightPx: 300 },
      orderOnForm: 30,
    },
  },
  async editCallback({ row, key, isNewRecord }) {
    // 新規・複製時のみ、開始日からコードをプレビュー（既存版のコードは変えない）
    if (isNewRecord && key === 'enabledFrom' && row.enabledFrom) {
      try {
        row.version = toStartDateVersionCode(String(row.enabledFrom))
      } catch {
        // 入力途中は無視
      }
    }
    return row
  },
  async beforeSave(saving) {
    return syncYhcMasterVersionFromMastersForm(saving)
  },
  formatDataAfterFetchFunctions: [
    {
      description: 'yhc_master_versions の期間・説明をフォーム用仮想カラムへ載せる',
      func: async (record) => hydrateYhcMastersWithVersionPeriod(record),
    },
  ],
  formatDataBeforeSaveFunctions: [
    {
      description: '仮想カラムを Directus payload から除外する',
      func: async (record) => stripYhcMastersVirtualPeriodFields(record),
    },
  ],
}
